/* eslint-disable linebreak-style */
import { setLocale } from 'yup';

setLocale({
  mixed: {
    required: 'Este campo é obrigatório',
  },
  string: {
    email: 'O campo deve ser um email válido',
  },
});
